module.exports = __webpack_public_path__ + "img/call_after_improved.a1a2c48.png";